var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/Breadcrumbs/BreadcrumbsList.tsx";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { ClickAwayListener, Collapse, ListItem, styled } from '@mui/material';
import React from 'react';
import { Paper } from '@gmini/ui-kit/lib/Paper';
import { Box } from '@gmini/ui-kit/lib/Box';
import { LongText } from '@gmini/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export var BreadcrumbsList = /*#__PURE__*/React.memo(function (_ref) {
  var breadcrumbsNodes = _ref.breadcrumbsNodes,
      open = _ref.open,
      onClose = _ref.onClose,
      onListClick = _ref.onListClick;
  return /*#__PURE__*/_jsx(Collapse, {
    "in": open,
    unmountOnExit: true,
    mountOnEnter: true,
    children: /*#__PURE__*/_jsx(ClickAwayListener, {
      onClickAway: onClose,
      children: /*#__PURE__*/_jsx(Paper, {
        children: breadcrumbsNodes.map(function (breadCrumbNode) {
          return /*#__PURE__*/_jsx(Box, {
            display: "flex",
            children: /*#__PURE__*/_jsx(List, {
              path: breadCrumbNode.item.path.length - 1,
              dense: true,
              onClick: function onClick(e) {
                return onListClick(breadCrumbNode, e);
              },
              children: /*#__PURE__*/_jsx(LongText, {
                partSize: 5,
                children: breadCrumbNode.name
              })
            }, breadCrumbNode.key)
          }, breadCrumbNode.key);
        })
      })
    })
  });
});
BreadcrumbsList.displayName = 'BreadcrumbsList';
export var List = styled(ListItem)(function (_ref2) {
  var theme = _ref2.theme,
      path = _ref2.path;
  return {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(12),
    paddingLeft: path * 20
  };
});